import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import {
  Backdrop,
  Box,
  ButtonBase,
  Grid,
  Modal,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";

import {
  BCPLocationDot,
  BCPPen,
  BCPSquarePlus,
  BCPTrash,
  BCPXmark,
} from "../icons/bcp/BCPIcons";

import { cleanLocation, deleteData, postData } from "./UtilityFunctions";
import GoogleMapsSearchBar from "./GoogleMapsSearchBar";
import { postNotification } from "./Notifications";
import ModalLoadingFull from "../modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";

export function LocationTextField(props) {
  const {
    label,
    location,
    setLocation,
    helperText,
    error,
    required,
    disabled,
  } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <TextField
        label={label || "Location"}
        variant="outlined"
        fullWidth
        required={required}
        margin="normal"
        value={location ? cleanLocation(location) : ""}
        InputProps={{
          sx: {
            cursor: "pointer",
            "& input": {
              cursor: "pointer",
            },
          },
          endAdornment: (
            <InputAdornment position="end">
              <BCPLocationDot />
            </InputAdornment>
          ),
        }}
        onClick={() => {
          if (!disabled) setOpen(true);
        }}
        error={error}
        helperText={helperText}
        disabled={disabled}
        autoComplete="off"
      />

      <LocationLiteModal
        open={open}
        setOpen={setOpen}
        setLocation={setLocation}
      />
    </>
  );
}

function LocationLiteModal(props) {
  const { open, setOpen, setLocation } = props;
  const [locData, setLocData] = useState(null);

  return (
    <>
      <Modal
        disableAutoFocus
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 9999 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setLocation(null);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" component="h2">
                Location Details
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <GoogleMapsSearchBar
                // initialSearch={}
                locationData={locData}
                setLocationData={setLocData}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="success"
                fullWidth
                onClick={async (e) => {
                  setLocation(locData);
                  setOpen(false);
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default function LocationPicker(props) {
  const {
    label,
    locationId,
    locations,
    setLocations,
    setLocation,
    setFieldTouched,
    helperText,
    error,
    required,
    disabled,
    placeholder,

    newLocationModalProps,
  } = props;
  const [open, setOpen] = useState(false);
  const [locationDict, setLocationDict] = useState({});
  const handleClose = (e) => {
    setOpen(false);
    if (setFieldTouched) setFieldTouched();
  };
  useEffect(() => {
    var lDict = {};
    if (locations?.length > 0) {
      locations.forEach((loc) => {
        lDict[loc.id] = loc;
      });
    }
    setLocationDict(lDict);
  }, [locations]);

  return (
    <>
      <TextField
        label={label || "Location"}
        variant="outlined"
        fullWidth
        placeholder={placeholder || ""}
        required={required}
        value={locationId ? cleanLocation(locationDict[locationId]) : ""}
        InputProps={{
          sx: {
            cursor: "pointer",
            "& input": {
              cursor: "pointer",
            },
          },
          endAdornment: (
            <InputAdornment position="end">
              <BCPLocationDot />
            </InputAdornment>
          ),
        }}
        onClick={() => {
          if (!disabled) setOpen(true);
        }}
        error={error}
        helperText={helperText}
        disabled={disabled}
        autoComplete="off"
      />
      <LocationsModal
        setLocation={setLocation}
        locations={locations}
        setLocations={setLocations}
        locationDict={locationDict}
        setLocationDict={setLocationDict}
        open={open}
        handleClose={handleClose}
        newLocationModalProps={newLocationModalProps}
      />
    </>
  );
}

function LocationsModal(props) {
  const {
    setLocation,
    setLocations,
    locations,
    locationDict,
    setLocationDict,
    open,
    handleClose,

    newLocationModalProps,
  } = props;
  const [modalLoc, setModalLoc] = useState(null);

  const authContext = useContext(AuthContext);
  const confirm = useConfirm();
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (open && !locations?.length) {
      setModalLoc({});
    }
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (open && !locations?.length && !modalLoc) {
      handleClose();
    }
    // eslint-disable-next-line
  }, [modalLoc]);

  return (
    <>
      <Modal
        disableAutoFocus
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 9999 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={handleClose}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" component="h2">
                Locations
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ pt: 1 }}>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => {
                  setModalLoc({});
                }}
                startIcon={<BCPSquarePlus />}
              >
                Add New
              </Button>
            </Grid>
            {locations?.length > 0 &&
              locations.map((loc, index) => {
                return (
                  <Grid key={index} item xs={12}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        sx={{
                          width: "calc(100% - 120px)",
                          maxWidth: "calc(100% - 120px)",
                        }}
                      >
                        <ButtonBase
                          sx={{
                            width: "100%",
                            display: "block",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            if (setLocation) {
                              setLocation(loc);
                            }
                            handleClose();
                          }}
                        >
                          {loc.name && <Typography>{loc.name}</Typography>}
                          {!loc.isOnline && (
                            <Typography variant="caption">
                              {`${
                                loc.name && loc.name !== ""
                                  ? `${loc.name}: `
                                  : ""
                              } ${cleanLocation(loc)}`}
                            </Typography>
                          )}
                        </ButtonBase>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          width: "60px",
                        }}
                      >
                        {!loc.isOnline && (
                          <Button
                            variant="contained"
                            sx={{ minWidth: "100%", maxWidth: "100%" }}
                            onClick={() => {
                              setModalLoc(loc);
                            }}
                          >
                            <BCPPen />
                          </Button>
                        )}
                      </Grid>
                      <Grid
                        item
                        sx={{
                          width: "60px",
                        }}
                      >
                        {!loc.isOnline && (
                          <Button
                            variant="contained"
                            color="error"
                            sx={{ minWidth: "100%", maxWidth: "100%" }}
                            onClick={async () => {
                              try {
                                await confirm({
                                  title: "Are you sure?",
                                  description:
                                    "Are you sure you want to delete this location? This will not affect any existing events, only new events.",
                                  dialogProps: {
                                    sx: {
                                      zIndex: 99999,
                                    },
                                  },
                                });
                              } catch (err) {
                                return;
                              }
                              try {
                                setProcessing(true);
                                await deleteData(`/locations/${loc.id}`);
                                if (setLocations) {
                                  setLocations(
                                    locations.filter((el) => el.id !== loc.id)
                                  );
                                }
                              } catch (err) {
                                postNotification("error", err);
                              }
                              setProcessing(false);
                            }}
                          >
                            <BCPTrash />
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        </Box>
      </Modal>
      {processing && <ModalLoadingFull />}
      <LocationModal
        location={modalLoc}
        setLocation={setModalLoc}
        newLocationModalProps={newLocationModalProps}
        onSave={async (loc) => {
          if (setLocation) {
            if (authContext?.authState?.identity?.userId) {
              // call API to update
              var apiData;
              try {
                if (modalLoc?.id) {
                  // update
                  apiData = await postData(`/locations/${modalLoc.id}`, {
                    body: {
                      set: {
                        ...loc,
                        ownerId: authContext?.authState?.identity?.userId,
                      },
                    },
                  });
                  if (setLocations) {
                    setLocations([apiData, ...locations]);
                  }
                } else {
                  // create
                  apiData = await postData(`/locations`, {
                    body: {
                      ...loc,
                      ownerId: authContext?.authState?.identity?.userId,
                    },
                  });
                  if (setLocations) {
                    var newLocations = [...locations];
                    for (var i = 0; i < newLocations.length; i++) {
                      if (newLocations[i].id === apiData.id) {
                        newLocations[i] = apiData;
                        break;
                      }
                    }
                    setLocations(newLocations);
                  }
                }

                setLocation(apiData);
                setLocationDict({ ...locationDict, [apiData.id]: apiData });
              } catch (err) {
                postNotification("error", err);
              }
            } else {
              var newLocation = {
                ...loc,
                id: "new",
              };
              setLocations([newLocation]);
              setLocation(newLocation);
              setLocationDict({ [newLocation.id]: newLocation });
            }
          }
          handleClose();
        }}
      />
    </>
  );
}

function LocationModal(props) {
  const { location, setLocation, onSave, newLocationModalProps } = props;
  const [loading, setLoading] = useState(false);
  const [locData, setLocData] = useState(null);
  const [name, setName] = useState({
    value: "",
    touched: false,
  });
  useEffect(() => {
    setLocData(location ? { ...location } : {});
    setName({ value: location?.name || "", touched: false });
    // eslint-disable-next-line
  }, [props]);

  const handleNameChange = (e) => {
    if (!e?.target || e.target.value === name.value) return;
    setName({
      value: e.target.value,
      touched: true,
    });
  };

  return (
    <>
      <Modal
        disableAutoFocus
        open={Boolean(location)}
        onClose={() => {
          setLocation(null);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ zIndex: 9999 }}
      >
        {Boolean(location) ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: ["95vw", "85vw", 600],
              maxHeight: "95vh",
              overflowY: "scroll",
              bgcolor: "background.paper",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
            }}
          >
            <IconButton
              aria-label="cancel"
              color="error"
              sx={{ position: "absolute", top: "4px", right: "4px" }}
              onClick={() => {
                setLocation(null);
              }}
            >
              <BCPXmark />
            </IconButton>
            <Grid
              container
              spacing={2}
              sx={{
                pb: 1,
                mb: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Grid item xs={12}>
                <Typography variant="h4" component="h2">
                  Location Details
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              {!newLocationModalProps?.hideName && (
                <Grid item xs={12}>
                  <TextField
                    label="Location Name"
                    value={name.value}
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    onBlur={handleNameChange}
                    onChange={handleNameChange}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <GoogleMapsSearchBar
                  initialSearch={cleanLocation(location)}
                  locationData={locData}
                  setLocationData={setLocData}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="success"
                  fullWidth
                  onClick={async (e) => {
                    if (!name.touched) setName({ ...name, touched: true });
                    setLoading(true);
                    var newLocData = {
                      ...locData,
                    };
                    if (name.value && name.value !== "") {
                      newLocData.name = name.value;
                    } else if (newLocData.formatted_address) {
                      newLocData.name = newLocData.formatted_address;
                    }
                    await onSave(newLocData);
                    setLoading(false);
                    setLocation(null);
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <></>
        )}
      </Modal>
      {loading && <ModalLoadingFull />}
    </>
  );
}
